import { render, staticRenderFns } from "./OrderListDeliveryAll.vue?vue&type=template&id=cc72b5e2&scoped=true"
import script from "./OrderListDeliveryAll.vue?vue&type=script&lang=js"
export * from "./OrderListDeliveryAll.vue?vue&type=script&lang=js"
import style0 from "./OrderListDeliveryAll.vue?vue&type=style&index=0&id=cc72b5e2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc72b5e2",
  null
  
)

export default component.exports